import React, { forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';

import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import Button from '@mui/material/Button';
import type { ToolbarProps } from '@mui/material/Toolbar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

const PrivacyModeBar = forwardRef<HTMLDivElement, ToolbarProps>((_props, ref) => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Toolbar
      ref={ref}
      variant='dense'
      style={{
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: theme.palette.info.main,
      }}
    >
      <Button
        onClick={() => navigate('/settings/general')}
        sx={{
          color: 'primary.contrastText',
        }}
      >
        <SecurityOutlinedIcon />
        &nbsp;
        <Typography>Privacy mode on &gt;</Typography>
      </Button>
    </Toolbar>
  );
});
PrivacyModeBar.displayName = 'PrivacyModeBar';
export default PrivacyModeBar;
